import React from 'react'
import { TextMediumSM } from '../../../../../Components/Text/MediumText'
import SubContractorType from './SubContractorType'
import SubContractorPeriod from './SubContractorPeriod'

const Index = () => {
  return (
    <>
    <TextMediumSM content="Contract" />
    <div className='w-full flex flex-wrap justify-center md:justify-start  items-center overflow-y-scroll'>
     
     <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
        <SubContractorType/>
     </div>
     <div className=' w-full md:w-1/2 lg:w-1/3 mt-4'>
        <SubContractorPeriod/>
     </div>
     
     </div>
     </>
  )
}

export default Index